











import { Component, Watch } from 'vue-property-decorator';
import PickerBase from './base';
import { sortByPickerData } from './base/utils';
import userSettingsApi from '@/views/settings/general/api';

@Component
export default class SortBy extends PickerBase {
  silent: boolean = true;
  value: string = 'reports-profit';
  param: string = 'orderBy';

  data: { value: string; title: string }[] = sortByPickerData().map((item:any) => ({
      value: item.pickerValue,
      title: item.title
  }));

  get dashboardDefaultGroup() {
    const { dashboardDefaultGroup } = this.$store.state.user;
    return dashboardDefaultGroup ? dashboardDefaultGroup : '';
  }

  created() {
    let val = this.dashboardDefaultGroup.includes('conversion') 
      ? 'conversion' 
      : this.dashboardDefaultGroup;
      
    let value = (this.data.find((e: any) => e.value.includes(val)) || {value:''}).value  || 'reports-profit';
    
    this.cache(true, this.param, value);

    const sorting = this.data.find((e: any) => (e.value === this.value)) || this.data[0];
    this.$store.commit('dashboardSortBy', sorting);
  }
  

  @Watch('value')
  sortBy(val: string) {
    if (!this.data.find((e: any) => e.value === val)) {
      this.value = (this.data.find((e: any) => e.value.includes(val)) || {value: ''}).value || 'reports-profit';
      return;
    }

    const sorting = this.data.find(e => e.value === val) || this.data[0];
    this.cache(false, this.param, sorting.value);

    this.$store.commit('dashboardSortBy', {
      title: sorting.title
    });
  }

}
